import React, { useState } from "react";
import { Dropdown } from "antd";
import AIIcon from "../../../components/AiIcon";


// TO ADD A NEW SKILLFORMBUTTON COLOR
// 1. add new "type" to styles object below using tailwind classes
// 2. add new new class to base.scss [.ant-dropdown .ant-dropdown-menu.new-skillform-button] with the same type name as in step 1
//     a. the css takes care of the dropdown background styles
// 3. TO USE: add type="yournewtype" to <NEWSkillFormButton /> 


const NEWSkillFormButton = ({
    skill,
    disabled,
    valuePropName = 'self_score',
    scoringOptions = laravel.talent_scoring_options,
    className,
    match,
    onChange,
    type = 'default',
    readonly = false,
    noMatch = false, // noMatch value has no-match styles = grayed out but can add | priority styling
    disableRemove = false,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const items = TB.map(scoringOptions, (label, key) => ({ label, key }))
    const valueExists = TB.isDefined(skill[valuePropName]);

    const canEdit = !readonly // !disabled // && (props.onlyEdit || !props.removeDisabled);
    const canAdd = canEdit && !valueExists;
    const canRemove = valueExists && !noMatch && canEdit && !disableRemove;


    const styles = {
        'no-match': {
            border: 'border-[#d3d8dd]',
            bg: 'bg-[#d3d8dd]',
            text: 'text-[#6d6d6d]',
            separator: 'bg-[#6d6d6d]',
        },
        'info': {
            border: 'border-wripplePrimaryMediumBlue',
            bg: 'bg-wripplePrimaryMediumBlue',
            text: 'text-wripplePrimaryMediumBlue',
            fill: '#4B80E7',
            icon: fillColor => (<AIIcon className="inline mr-1 -mt-[4px]" size={22} fill={fillColor || '#ff0'} />)
        },
        'default': {
            border: 'border-secondary',
            bg: 'bg-secondary',
            text: 'text-secondary',
        }
    }

    return (
        <div className="relative new-skillsformbutton inline-block">
            <div className="flex flex-col">

                <Dropdown
                    menu={{
                        items,
                        disabled: disabled || readonly,
                        selectedKeys: [String(skill[valuePropName])],
                        className: `new-skillform-button ${type}`,
                        onClick: async e => {
                            // console.log(e, skill[valuePropName], valuePropName, 'eeee')
                            setIsOpen(false)
                            await TB.wait(100);
                            onChange({ ...skill, [valuePropName]: e.key })
                        },
                    }}
                    trigger={['click']}
                    // className={!disabled && 'cursor-pointer'}
                    className={TB.mapClass(className, { 'cursor-pointer': !disabled && !readonly })}
                    disabled={disabled || readonly}
                    open={isOpen}
                    onOpenChange={e => setIsOpen(e)}
                >
                    <div className="inline-flex flex-col">
                        <div
                            className={TB.mapClass('h-[30px] py-1.5 transition delay-100 rounded-[46px] border bordersecondary inline-flex justify-center items-cente z-[1]', {
                                [`${styles[type].bg} ${styles[type].border}`]: valueExists || isOpen,
                                [`bg-white ${styles[type].border}`]: !valueExists && !isOpen && !noMatch,
                                [`${styles['no-match'].bg} ${styles['no-match'].border}`]: noMatch && !isOpen,
                            })}
                        >
                            <p
                                className={TB.mapClass('text-[11px] flex-1 flex justify-center transition delay-100 text-center font-medium mt-px py1.5 px-3', {
                                    [`${styles[type].text}`]: !valueExists && !isOpen && !noMatch,
                                    'text-white': valueExists || isOpen,
                                    [`${styles['no-match'].text}`]: noMatch && !isOpen,
                                })}
                            >
                                {match && (
                                    <div className="bg-wripplePrimaryPaleGreen mr-1.5 mt-1 rounded-full h-[0.6em] w-[0.6em]" />
                                )}
                                {styles[type].icon?.(!valueExists && !isOpen ? `${styles[type].fill}` : '#fff')}

                                {skill.name}
                            </p>

                            {canRemove && (
                                <>
                                    <div className="w-px h-full transition delay-100 bg-white" />
                                    <button
                                        disabled={disabled}
                                        type="button"
                                        onClick={e => {
                                            if (!isOpen && valueExists) {
                                                e.stopPropagation(); // ignore opening menu when clicking minus/remove button
                                                onChange({ ...skill, [valuePropName]: undefined })
                                            }
                                        }}
                                        className="py1.5 px-3 flex items-center justify-center"
                                    >
                                        <i
                                            className={TB.mapClass('text-xxs transition delay-100', {
                                                'fa fa-chevron-up text-white': isOpen,
                                                'fa fa-minus text-white': valueExists && !isOpen,
                                            })}
                                        />
                                    </button>
                                </>
                            )}

                            {canAdd && (
                                <>
                                    <div
                                        className={TB.mapClass('w-px h-full transition delay-100', {
                                            'bg-white': valueExists || isOpen,
                                            [`${styles[type].bg}`]: !valueExists && !isOpen && !noMatch,
                                            [`${styles['no-match'].separator}`]: noMatch && !isOpen,
                                        })}
                                    />
                                    <p className="py1.5 px-3 flex items-center justify-center">
                                        <i
                                            className={TB.mapClass('text-xxs transition delay-100', {
                                                'fa fa-chevron-up text-white': isOpen,
                                                [`fa fa-plus ${styles[type].text}`]: !valueExists && !isOpen && !noMatch,
                                                [`fa fa-plus ${styles['no-match'].text}`]: noMatch && !isOpen,
                                            })}
                                        />
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </Dropdown>
                {valueExists && (
                    <button
                        type="button"
                        disabled={disabled || readonly}
                        onClick={() => setIsOpen(!isOpen)}
                        className={`bg-white border borderpurple-500 ${styles[type].border} rounded-br-[20px] rounded-bl-[20px] pt-4 pb-0.5 -mt-[0.8rem] inline-flexitems-center px-3`}
                    >
                        <p className={`text-[11px] textsecondary ${styles[type].text} font-medium text-center`}>
                            {scoringOptions[skill[valuePropName]]}
                            {canEdit && <i className="fa fa-chevron-down text-xxs ml-1" />}
                        </p>
                    </button>
                )}

                {noMatch && (
                    <button
                        type="button"
                        disabled={disabled || readonly}
                        onClick={() => setIsOpen(!isOpen)}
                        className={`bg-white border borderpurple-500 ${styles['no-match'].border} rounded-br-[20px] rounded-bl-[20px] pt-4 pb-0.5 -mt-[0.8rem] inline-flexitems-center px-3`}
                    >
                        <p className={`text-[11px] textsecondary ${styles['no-match'].text} font-medium text-center`}>
                            No Experience
                        </p>
                    </button>
                )}
            </div>

        </div>
    );
}

export default NEWSkillFormButton;